export function LeaveStatusBadge({ status }) {
  const map = {
    Approved: "bg-success/12 text-success",
    Pending: "bg-warning/12 text-warning",
    Rejected: "bg-error/12 text-error",
    Withdrawn: "bg-(--color-text-secondary)/12 per-file-hint",
    Revoked: "bg-(--color-text-secondary)/12 per-file-hint",
    Cancelled: "bg-(--color-text-secondary)/12 per-file-hint",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold whitespace-nowrap ${map[status] || "bg-(--color-text-secondary)/12 per-file-hint"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
